<template>
  <div id="scatter_plots" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-2" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-2" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2" v-if="x_axis_dropdown.data != undefined">
        <label class="typo__label">{{ x_axis_dropdown.label }}</label>
        <multiselect
          v-model="x_axis_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="x_axis_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
      <div class="col-md-2" v-if="x_axis_dropdown.data != undefined">
        <label class="typo__label">X Axis Type</label>
        <multiselect
          v-model="x_axis_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="axis_type_options"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2" v-if="y_axis_dropdown.data != undefined">
        <label class="typo__label">{{ y_axis_dropdown.label }}</label>
        <multiselect
          v-model="y_axis_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="y_axis_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
        <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
      <div class="col-md-2" v-if="y_axis_dropdown.data != undefined">
        <label class="typo__label">Y Axis Type</label>
        <multiselect
          v-model="y_axis_type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          :options="axis_type_options"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Show Graph</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <svg width="960" height="600"></svg>

  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import { season, seasonType, chart } from './mixins/dropdowns'
const d3 = require('d3')

export default {
  name: 'ScatterPlots',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect
  },
  mixins: [SeasonTypeSelect, SeasonSelect, GetDropdownOptions, season, seasonType, chart],
  data () {
    return {
      loading: false,
      season_type_dropdown: {},
      season_type_selected: undefined,
      season_dropdown: {},
      seasons_selected: [],
      x_axis_dropdown: {},
      x_axis_selected: undefined,
      y_axis_dropdown: {},
      y_axis_selected: undefined,
      season_selected_string: '',
      axis_type_options: [
        {'id': 'Team', 'text': 'Team'},
        {'id': 'Opponent', 'text': 'Opponent'}
      ],
      x_axis_type_selected: undefined,
      y_axis_type_selected: undefined,
      show_error_message: false,
      api_endpoint: 'get-scatter-plots/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      d3.selectAll('svg > *').remove()
      this.results = []
      this.seasons_selected = []
      this.season_selected_string = ''
      this.$router.push({name: 'scatter_plots', params: {league: this.$parent.league}})
    },
    setAxisDropdowns () {
      this.x_axis_dropdown = {'label': 'X Axis', 'data': this.chart_dropdown_options}
      this.y_axis_dropdown = {'label': 'Y Axis', 'data': this.chart_dropdown_options}

      this.x_axis_dropdown.data.forEach((xAxis) => {
        if (xAxis.id === this.$route.query.Xaxis) {
          this.x_axis_selected = xAxis
        }
      })

      this.y_axis_dropdown.data.forEach((yAxis) => {
        if (yAxis.id === this.$route.query.Yaxis) {
          this.y_axis_selected = yAxis
        }
      })

      if (this.$route.query.YaxisType === 'Opponent') {
        this.y_axis_type_selected = this.axis_type_options[1]
      }

      if (this.$route.query.XaxisType === 'Opponent') {
        this.x_axis_type_selected = this.axis_type_options[1]
      }
    },
    checkIfStatsShouldBeLoaded () {
      if (this.seasons_selected.length > 0 && this.season_type_selected && this.x_axis_selected && this.y_axis_selected) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setAxisDropdowns, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id
      params[this.$xAxisParam] = this.x_axis_selected.id
      params[this.$yAxisParam] = this.y_axis_selected.id

      if (this.x_axis_type_selected.id === 'Opponent') {
        params[this.$xAxisTypeParam] = 'Opponent'
      }
      if (this.y_axis_type_selected.id === 'Opponent') {
        params[this.$yAxisTypeParam] = 'Opponent'
      }

      this.$router.push({name: 'scatter_plots', query: params})
    },
    getStats () {
      this.show_error_message = false
      var params = this.$route.query

      if (params.Season && params.SeasonType) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.results = response.data.results
              this.x_axis_label = response.data.x_axis_label
              this.y_axis_label = response.data.y_axis_label
              this.addChart()
              this.loading = false
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    },
    addChart () {
      d3.selectAll('svg > *').remove()
      var xMax = d3.max([d3.max(this.results, function (d) { return d.x })])
      var xMin = d3.min([d3.min(this.results, function (d) { return d.x })])
      var yMax = d3.max([d3.max(this.results, function (d) { return d.y })])
      var yMin = d3.min([d3.min(this.results, function (d) { return d.y })])

      // outer svg dimensions
      const width = 600
      const height = 400

      // padding around the chart where axes will go
      const padding = {
        top: 20,
        right: 20,
        bottom: 40,
        left: 50
      }

      // inner chart dimensions, where the dots are plotted
      const plotAreaWidth = width - padding.left - padding.right
      const plotAreaHeight = height - padding.top - padding.bottom

      // radius of points in the scatterplot
      const pointRadius = 3

      // initialize scales
      const xScale = d3.scaleLinear().domain([0.98 * xMin, xMax]).range([0, plotAreaWidth])
      const yScale = d3.scaleLinear().domain([0.98 * yMin, yMax]).range([plotAreaHeight, 0])

      // initialize main SVG
      var svg = d3.select('svg')
        .attr('width', width)
        .attr('height', height)

      // the main <g> where all the chart content goes inside
      const g = svg.append('g')
        .attr('transform', `translate(${padding.left} ${padding.top})`)

      // add in axis groups
      const xAxisG = g.append('g').classed('x-axis', true)
        .attr('transform', `translate(0 ${plotAreaHeight + pointRadius})`)

      // x-axis label
      g.append('text')
        .attr('transform', `translate(${plotAreaWidth / 2} ${plotAreaHeight + (padding.bottom)})`)
        .attr('dy', -4) // adjust distance from the bottom edge
        .attr('class', 'axis-label')
        .attr('text-anchor', 'middle')
        .text(this.x_axis_label)

      const yAxisG = g.append('g').classed('y-axis', true)
        .attr('transform', `translate(${-pointRadius} 0)`)

      // y-axis label
      g.append('text')
        .attr('transform', `rotate(270) translate(${-plotAreaHeight / 2} ${-padding.left})`)
        .attr('dy', 12) // adjust distance from the left edge
        .attr('class', 'axis-label')
        .attr('text-anchor', 'middle')
        .text(this.y_axis_label)

      // set up axis generating functions
      const xTicks = Math.round(plotAreaWidth / 50)
      const yTicks = Math.round(plotAreaHeight / 50)

      const xAxis = d3.axisBottom(xScale)
        .ticks(xTicks)
        .tickSizeOuter(0)

      const yAxis = d3.axisLeft(yScale)
        .ticks(yTicks)
        .tickSizeOuter(0)

      // draw the axes
      yAxisG.call(yAxis)
      xAxisG.call(xAxis)

      // team labels
      g.append('g').attr('class', 'team_labels')
        .selectAll('.data-label')
        .data(this.results)
        .enter()
        .append('text')
        .text(function (d) { return d.label })
        .attr('x', function (d) { return xScale(d.x) })
        .attr('y', function (d) { return yScale(d.y) })
        .attr('text-anchor', 'middle')
        .attr('font-size', '12px')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ScatterPlots.vue